.pane {
  display: flex;
  flex: 1 0 auto;
  box-sizing: border-box;
  min-block-size: calc(100dvh - var(--unified-shell-header-height, 50px));
  padding: var(--space__2xl) var(--unified-shell-gutter, var(--space__xl));
  background: var(--color__white);
}
